import React, { useCallback } from 'react'
import clsx from 'classnames'
import type { PopulatedAppointment } from 'src/hooks/usePopulatedAppointments'
import { VisitCard } from './VisitCard'
import styles from './Visit.module.scss'

type PastVisitProps = {
  visit: PopulatedAppointment,
  reviewDisabled: boolean,
  className?: string,
  onClickRepeat: (e: React.MouseEvent) => void,
  onClickReview: (e: React.MouseEvent) => void,
}

/** A finished visit: rate it (within two weeks, once) or book the same again */
export const PastVisit: React.FC<PastVisitProps> = React.memo((props) => {
  const { visit, reviewDisabled, className, onClickRepeat, onClickReview } = props

  const handleReviewClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation()
    if (reviewDisabled || visit.rating !== null) {
      return
    }
    onClickReview(e)
  }, [reviewDisabled, visit.rating, onClickReview])

  const handleRepeatClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation()
    onClickRepeat(e)
  }, [onClickRepeat])

  const ratingIconClass = clsx({
    [styles.ratingIcon]: true,
    [styles.hasRating]: visit.rating !== null,
    [styles.disabled]: reviewDisabled,
  })

  return (
    <VisitCard
      className={clsx([styles.container, styles.past, className])}
      visit={visit}
      icon={<i className={ratingIconClass} onClick={handleReviewClick} />}
      discountAmount={visit.discountAmount}
      actions={[{ name: 'repeat', title: 'Повторить', onClick: handleRepeatClick }]}
    />
  )
})
PastVisit.displayName = 'PastVisit'
